import { Deserializable } from '../deserializable';

export class Note implements Deserializable {
  id: number;
  clientId: number;
  note: string;
  dateTimeCreated: Date;
  createdByUserId: number;
  createdByUserFullName: string;

  recentlyUpdated: boolean;
  noteTypeDescription: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
